export default __webpack_public_path__ + "static/layer780-8b05a3875ae0660266899346c2c0d27a.jpg";